import type { DepartmentI, DepartmentFilterI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

class DepartmentsApi extends BaseApi<DepartmentI, DepartmentFilterI> {
  /**
   * Actualiza el estatus de un departamente en específico.
   * @param id - id del departamento
   * @param data - el nuevo estatus que tendra el apartamento.
   * @returns - { success: boolean } indicando el resultado
   */
  async patch(id: string, data: { status: boolean }) {
    const response = await fetchData<{ status: boolean }>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data,
    });
    return response;
  }
}

const departmentsApi = new DepartmentsApi('/departments');

export default departmentsApi;
